/**
 * Calculates the number of pages
 *
 * @param totalItems
 * @param itemsPerPage
 */
export var getTotalPages = function (totalItems, itemsPerPage) {
    if (totalItems === 0) {
        return 0;
    }
    if (!itemsPerPage || itemsPerPage === 0) {
        throw new Error('itemsPerPage is possibly causing a division by 0');
    }
    return Math.ceil(totalItems / itemsPerPage);
};
//# sourceMappingURL=utils.js.map